module.exports = __webpack_public_path__ + "img/messagewelcome.35d9d60.png";